export const opcionesRectificacion = [
  { 
    value: 'logroUsuarios', 
    label: 'Rectificar logros generales', 
    description: 'Asigna un logro a todos los jugadores' 
  },
];
